export const getDiscoveryUserRoute = () => 'buzzAppCentral/discoveryAppUser';
export const employeeRoute = () => 'auth/identity/bccUser/signup';
export const allEmployeeRoute = () => 'user/bcc/all';
export const updateUserRoute = (id) => `user/bcc/${id}`;
